<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'
             title="Thêm mới"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model.trim="model.code"
               label="Mã vai trò"
               validate-rules="required"
      />

      <c-input v-model.trim="model.description"
               label="Mô tả"
               validate-rules="required"
      />

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        code: null,
        description: null,
      },
    }
  },
  methods: {
    resetForm() {
      this.model = {
        code: null,
        description: null,
      }
    },
    submit() {
      this.$showLoader();
      let data = {
        "code": this.model.code,
        "description": this.model.description
      }
      this.$http
          .post("/cms/api/v1.0/admin/roles", data)
          .then(successRes => {
            this.close();
            this.$success();
            this.$stopLoader();

            this.$emit("success", successRes);
          }, errorRes => {
            this.$stopLoader();
            this.errorNotify(errorRes);
            this.$emit("error", errorRes);
          })
      ;
    }
  }
}
</script>

<style scoped>

</style>